import Vue from 'vue'
import { isTouchDevice, handleize } from '@/lib/util'
let interval

Vue.component('tabs', {
  props: {
    styleTabButtons: {
      type: String,
      default: 'h4',
    },
    autoPlay: {
      type: Boolean,
      default: false,
    },
    speed: {
      type: Number,
      default: 4, // seconds
    },
    controls: {
      type: Boolean,
      default: false,
    },
    tabDescription: {
      type: String,
      default: '',
    },
    hide: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: 'Tab',
    }
  },
  data() {
    return {
      selectedIndex: 1,
      tabs: [],
      tempPause: false,
      isPlaying: false,
      currentProgress: 1,
      contentObserver: null,
      isActive: false,
    }
  },
  computed: {
    controlButtonDesc() {
      return `Tabs can be ${
        this.isPlaying ? 'paused' : 'played'
      } by using this button${
        this.isPlaying ? ', or paused on mouse enter' : ''
      }`
    },
  },
  watch: {
    'selectedIndex' () {
      if (this.autoPlay) {
        setTimeout(() => {
          this.$refs.progressBar && this.startProgress(this.$refs.progressBar[this.selectedIndex])
        }, 300)
      }
      this.$emit('tab-selected', this.selectedIndex)
    },
  },
  mounted() {
    this.getTabsFromSlot()
    this.observeContentChange()

    if (this.autoPlay) this.isPlaying = true
  },
  beforeUnmount() {
    this.contentObserver.disconnect()
  },
  methods: {
    handleize,
    getTabsFromSlot() {
      const slot = this.$slots.default
      if (slot) {
        const tabs = slot.filter((t) => !!t.tag).map((t) => t.data.attrs)
        this.tabs = tabs
        this.$nextTick(() => {
          this.selectTab(0)
        })
      }
    },
    selectTab(i) {
      this.selectedIndex = i

      this.tabs.forEach((tab, index) => {
        tab.isActive = index === i
      })

      this.$emit('tab-selected', this.selectedIndex)
    },
    changeToNextTab() {
      if (!this.tabs.length) {
        return
      }

      let activeIndex = this.tabs.findIndex((tab) => tab.isActive)

      if (activeIndex === -1) {
        activeIndex = 0
      }

      activeIndex++

      if (activeIndex >= this.tabs.length) {
        activeIndex = 0
      }
      this.selectTab(activeIndex)
    },
    startProgress(item) {
      if (!item) return
      this.currentProgress = 0
      clearInterval(interval)

      interval = setInterval(() => {
        if (this.currentProgress >= 100) {
          clearInterval(interval)
          item.style.width = '0'
          this.changeToNextTab()
        } else {
          item.style.width = this.currentProgress + '%'
          if (this.tempPause) return
          if (this.controls && !this.isPlaying) return

          this.currentProgress = this.currentProgress + 1
        }
      }, this.speed * 10)
    },
    togglePlayTabs() {
      this.isPlaying = !this.isPlaying
    },
    handleMouseenter() {
      if (isTouchDevice()) return
      this.tempPause = true
    },
    handleMouseleave() {
      if (isTouchDevice()) return
      this.tempPause = false
    },
    handleClick(e) {
      if (this.$refs.header.contains(e.target) || !isTouchDevice()) return
      this.tempPause = !this.tempPause
    },
    observeContentChange() {
      const config = { attributes: false, childList: true, subtree: false }
      const callback = () => {
        this.getTabsFromSlot()
      }
      this.contentObserver = new MutationObserver(callback)
      this.contentObserver.observe(this.$refs.tabContent, config)
    },
  },
  template: `
    <div
      :class="{
      'tabs--default': !autoPlay,
      'tabs--is-playing': isPlaying,
    }"
      class="tabs"
      @mouseenter="handleMouseenter"
      @mouseleave="handleMouseleave"
      @click="handleClick"
    >
      <div ref="header" class="flex items-center tabs__header">
        <ul class="tabs__tablist" role="tablist">
          <li
            v-for="(tab, i) in tabs"
            :key="i"
            role="presentation"
            class="tabs__tab"
          >
            <button
              :id="'tab-'+ handleize(tab.title)"
              class="tabs__title"
              :class="[
                { 'tabs__title--last-child': i === tabs.length - 1 },
                { 'tabs__title--active': selectedIndex === i },
                { 'tabs__title--played': selectedIndex > i },
                styleTabButtons,
              ]"
              type="button"
              role="tab"
              :tabindex="selectedIndex === i ? '0' : '-1'"
              :aria-selected="selectedIndex === i"
              :aria-controls="'tab-panel-'+ handleize(tab.title)"
              :aria-description="tabDescription"
              :name="tab.title"
              @click="selectTab(i)"
            >
              <span v-html="tab.title"></span>
              <span ref="progressBar" class="tab__progress"></span>
            </button>
          </li>
        </ul>
        <button
          v-if="controls"
          ref="controlButton"
          class="tabs__control-button"
          :aria-label="isPlaying ? 'Pause Tabs' : 'Play Tabs'"
          :aria-description="controlButtonDesc"
          @click="togglePlayTabs"
        ></button>
      </div>

      <div ref="tabContent" class="tabs__content">
        <slot></slot>
      </div>
    </div>`
})